<template>
    <div id="team" class="team">
      <div class="team-block" v-for="(item, index) in team" :key="index">
        <span class="team-block--title scrollFadeText">{{item.title}}</span>
        <p class="team-block--content scrollFadeBody">
          {{ item.text }}
        </p>
      </div>
    </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'PageView',
        'pagePath': '/team',
        'pageTitle': 'Parker West | Team'
    })
    export default {
      name: "Team",
      data: () => ({
        team: []
      }),
        metaInfo: {
            // Define meta tags here.
            titleTemplate: '%s ← Team',
            meta: [
                {name: 'description', content: 'Team penthouse page'}
            ],
            link: [
                {rel: 'canonical', href: 'http://test.parkerwest.com/'}
            ]
        },
      created() {
          this.team = window.data.team;
          window.addEventListener('scroll', this.handleScroll);
      },
      methods: {
        handleScroll () {
            // Scroll fade
            let slidesTitle = document.getElementsByClassName("scrollFadeText");
            let slidesBody = document.getElementsByClassName("scrollFadeBody");


            for (let i = 0; i < slidesTitle.length; i++) {
                let elPos = slidesTitle[i].getBoundingClientRect().top
                if(elPos < 120) {
                    slidesTitle[i].style.opacity = (elPos / 200)
                } else {
                    slidesTitle[i].style.opacity = 1
                }
            }

            for (let i = 0; i < slidesBody.length; i++) {
                let elPos = slidesBody[i].getBoundingClientRect().top
                if(elPos < 120) {
                    slidesBody[i].style.opacity = (elPos / 200)
                } else {
                    slidesBody[i].style.opacity = 1
                }
            }
        }
      },
      destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
      },
    }
</script>

<style scoped>

</style>
